import React from 'react'
import { SettingsListItem } from '@/shared/ui/SettingsListItem'
import { useTranslation } from 'react-i18next'
import { Logout } from '@/shared/ui/Icons'
import { useAppStore, useVisibilityStore } from '@/shared/store'
import { defaultProfile } from '@/shared/constants'
import { getConfigRepository } from '@/shared/getContainer/getConfigRepository'

interface Props {
    onClose: () => void
}

const ConfigRepository = await getConfigRepository()
const configRepository = ConfigRepository.Instance

const LogoutButton = ({ onClose }: Props) => {
    const { t: translate } = useTranslation()
    const { setLoginContentVisible } = useVisibilityStore()
    const { setIsUserLoggedIn, setActualProfile, setProfiles, reset } =
        useAppStore()

    const handleClick = () => {
        setActualProfile(defaultProfile)
        setProfiles([])

        localStorage.clear()
        onClose()
        setLoginContentVisible()
        configRepository.removeConfig()
        setIsUserLoggedIn(false)
        reset()
    }

    return (
        <SettingsListItem
            key={translate('logout')}
            icon={<Logout />}
            name={translate('logout')}
            onClose={handleClick}
            link={'/'}
        />
    )
}

export { LogoutButton }
